import { Button, CircularProgress } from "@mui/material";

export default function BusyButton({ loading = false, disabled, startIcon, children, ...rest }) {
    return (
        <Button
            {...rest}
            disabled={disabled || loading}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : startIcon}
        >
            {children}
        </Button>
    );
}
